import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core'
import { Store } from '@ngrx/store'
import { Subject } from 'rxjs'
import { finalize, first, takeUntil } from 'rxjs/operators'
import { HubtypeBot } from '../../../models/hubtype-bot'
import * as fromRoot from '../../../reducers'
import { BotService } from '../../../services/hubtype-api/bot.service'

@Component({
  selector: 'app-channels-zendesk',
  templateUrl: './zendesk.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./zendesk.component.scss'],
  standalone: false,
})
export class ZendeskComponent implements OnInit, OnDestroy {
  public bot: HubtypeBot
  private ngUnsubscribe: Subject<void> = new Subject<void>()
  public feedback: string

  zendeskChannel = {
    zendeskUsername: '',
    zendeskDomain: '',
    zendeskToken: '',
  }

  constructor(
    private store: Store<fromRoot.State>,
    private ref: ChangeDetectorRef,
    private botService: BotService
  ) {}

  ngOnInit() {
    this.store
      .select(fromRoot.getBot)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(bot => {
        this.ref.markForCheck()
        this.bot = bot
      })
  }

  addZendesk() {
    this.botService
      .addIntegration(this.bot)
      .pipe(
        first(),
        finalize(() => this.ref.markForCheck())
      )
      .subscribe(
        res => {
          this.feedback = 'Integrated!'
          this.bot.zendesk_is_active = true
        },
        err => {
          this.feedback = 'There was an error during the integration'
          this.bot.zendesk_is_active = false
        }
      )
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }
}
